import * as Sentry from '@sentry/nextjs';
import { getErrorMessage } from './getErrorMessage';

/**
 * Reports an error to Sentry and the console.
 *
 * When `outerMessage` is set, Sentry receives a wrapper whose message joins that label
 * and the original message, with the original error as `cause`.
 * @param err The error to report.
 * @param outerMessage Optional label prepended to the message.
 * @param level Sentry level. Omitted calls keep Sentry's default error level.
 * @returns The message written to the console.
 */
export function exception(
  err: unknown,
  outerMessage?: string,
  level?: Sentry.SeverityLevel,
): string {
  let message = getErrorMessage(err);
  const originalException = err;

  if (outerMessage) {
    message = outerMessage + ': ' + message;
    err = new Error(message, { cause: err });
  }

  if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true') {
    if (level != null) {
      Sentry.captureException(err, { level });
    } else {
      Sentry.captureException(err);
    }
  }

  console.error(message);
  if (message.endsWith(': Unknown error') && process.env.NODE_ENV === 'development') {
    console.error('Unhandled error detail:', originalException);
  }

  return message;
}
